module.exports = "/static/assets/ae564de8d4f7ca1a034180221227e91b.png";